// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H9yV","left":"styles_left__2xRbe","desktopActions":"styles_desktopActions__1Wg-p","title":"styles_title__21oBI"};